import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import "rxjs/add/operator/take";
import { Observable } from "rxjs/Rx";
import { Subject } from "rxjs/Subject";
import { map } from "rxjs/operators";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { BehaviorSubject } from "rxjs";
import { PushNotificationTemplateModel } from "../../components/dashboard/shared/dashboard.model";
import { environment } from "../../../environments/environment";
import { UnreadNotificationModel, UserNotificationDataModel } from "../../views/login/login.model";

@Injectable()
export class MessagingService {
  currentMessage = new BehaviorSubject(null);
  token: Subject<any>;
  pushNotificationTemplateModel: PushNotificationTemplateModel =
    new PushNotificationTemplateModel();
  pushNotificationAlert: Subject<PushNotificationTemplateModel>;
  messaging;
  constructor(
    private http: HttpClient,
    private angularFireMessaging: AngularFireMessaging
  ) {
    this.token = new Subject();
    this.pushNotificationAlert = new Subject();
    //this.messaging = firebase.messaging();
  }

  // receiveMessage() {
  //   this.angularFireMessaging.messages.subscribe(
  //     (payload) => {
  //       console.log("new message received. ", payload);
  //       this.currentMessage.next(payload);
  //     })
  // }

  getPermission() {
    this.angularFireMessaging.requestPermission.subscribe(() => {
      this.angularFireMessaging.getToken.subscribe(
        (token) => {
          if (token) {
            localStorage.setItem("notification_token", token);
            this.token.next(token);
          } else {
            // Show permission request UI
            console.log(
              "No registration token available. Request permission to generate one."
            );
            // ...
          }
        },
        () => (err) => {
          console.log("An error occurred while retrieving token. ", err);
          // ...
        }
      );
    });
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload: any) => {
        // this.pushNotificationTemplateModel.eventUserId =
        //   payload.data["gcm.notification.eventUId"];
        // //this.pushNotificationTemplateModel.icon = payload.notification.icon;
        // this.pushNotificationTemplateModel.notificationBody = payload.data.body;
        // this.pushNotificationTemplateModel.notificationHeader =
        //   payload.data.title;
        // this.pushNotificationTemplateModel.redirectLink =
        //   payload.data.redirectUrl;
        // this.pushNotificationAlert.next(
        //   <PushNotificationTemplateModel>this.pushNotificationTemplateModel
        // );
        this.currentMessage.next(payload);
      },
      (err) => {
      }
    );
  }

  getUnreadNotificationCount(): Observable<UnreadNotificationModel> {
    return this.http
      .get(
        environment.notification_url +
          "notification/token/getUnreadNotificationsCount"
      )
      .pipe(map((res: UnreadNotificationModel) => res));
  }

    getNotificationList(params): Observable<UserNotificationDataModel> {
    const url =
      environment.notification_url + "notification/token/getAllNotifications";
    return this.http.get(url , {params : params}).pipe(
      map((response: UserNotificationDataModel) => {
        return response;
      })
    );
  }

  markNotificationAsRead(data): Observable<any> {
    const url = environment.notification_url + "notification";
    return this.http.put(url, data).pipe(map((res: any) => res));
  }
}
